/* eslint-disable import/no-anonymous-default-export */
import img_0 from "../assets/animation_images/img_0.jpg";
import img_1 from "../assets/animation_images/img_1.jpg";
import img_2 from "../assets/animation_images/img_2.jpg";
import img_3 from "../assets/animation_images/img_3.jpg";
import img_4 from "../assets/animation_images/img_4.jpg";
import img_5 from "../assets/animation_images/img_5.jpg";
import img_6 from "../assets/animation_images/img_6.jpg";
import img_7 from "../assets/animation_images/img_7.jpg";
import img_8 from "../assets/animation_images/img_8.jpg";
import img_9 from "../assets/animation_images/img_9.jpg";
import img_10 from "../assets/animation_images/img_10.jpg";
import img_11 from "../assets/animation_images/img_11.jpg";
import img_12 from "../assets/animation_images/img_12.jpg";

export default {
  v: "5.7.8",
  fr: 25,
  ip: 0,
  op: 60,
  w: 1920,
  h: 2037,
  nm: "Asamba Circles_layered",
  ddd: 0,
  assets: [
    {
      id: "image_0",
      w: 755,
      h: 627,
      u: "",
      p: img_0,
      e: 0,
    },
    {
      id: "image_1",
      w: 1497,
      h: 1291,
      u: "",
      p: img_1,
      e: 0,
    },
    {
      id: "image_2",
      w: 950,
      h: 939,
      u: "",
      p: img_2,
      e: 0,
    },
    {
      id: "image_3",
      w: 553,
      h: 553,
      u: "",
      p: img_3,
      e: 0,
    },
    {
      id: "image_4",
      w: 605,
      h: 605,
      u: "",
      p: img_4,
      e: 0,
    },
    {
      id: "image_5",
      w: 1456,
      h: 1456,
      u: "",
      p: img_5,
      e: 0,
    },
    {
      id: "image_6",
      w: 325,
      h: 325,
      u: "",
      p: img_6,
      e: 0,
    },
    {
      id: "image_7",
      w: 812,
      h: 807,
      u: "",
      p: img_7,
      e: 0,
    },
    {
      id: "image_8",
      w: 654,
      h: 654,
      u: "",
      p: img_8,
      e: 0,
    },
    {
      id: "image_9",
      w: 1243,
      h: 1243,
      u: "",
      p: img_9,
      e: 0,
    },
    {
      id: "image_10",
      w: 1288,
      h: 1288,
      u: "",
      p: img_10,
      e: 0,
    },
    {
      id: "image_11",
      w: 471,
      h: 471,
      u: "",
      p: img_11,
      e: 0,
    },
    {
      id: "image_12",
      w: 873,
      h: 471,
      u: "",
      p: img_12,
      e: 0,
    },
  ],
  fonts: {
    list: [
      {
        fName: "Inter-Regular",
        fFamily: "Inter",
        fStyle: "Regular",
        ascent: 72.7264404296875,
      },
    ],
  },
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 5,
      nm: "SIGHT",
      parent: 29,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 20,
              s: [0],
            },
            { t: 27, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-596.219, 3.808, 0], ix: 2, l: 2 },
        a: { a: 0, k: [34.535, 0.23, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 18,
                f: "Inter-Regular",
                t: "SIGHT",
                ca: 0,
                j: 0,
                tr: 147,
                lh: 21.6,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: [
          {
            nm: "Animator 1",
            s: {
              t: 0,
              xe: { a: 0, k: 0, ix: 7 },
              ne: { a: 0, k: 0, ix: 8 },
              a: { a: 0, k: 100, ix: 4 },
              b: 1,
              rn: 0,
              sh: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 20,
                    s: [0],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 30,
                    s: [100],
                  },
                  { t: 82.5625, s: [100] },
                ],
                ix: 1,
              },
              r: 1,
            },
            a: { o: { a: 0, k: 0, ix: 9 } },
          },
        ],
      },
      ip: 20,
      op: 60,
      st: 20,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 5,
      nm: "SOUND",
      parent: 29,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 12,
              s: [0],
            },
            { t: 19, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-463.26, -334.942, 0], ix: 2, l: 2 },
        a: { a: 0, k: [39.994, 0.23, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 18,
                f: "Inter-Regular",
                t: "SOUND",
                ca: 0,
                j: 0,
                tr: 147,
                lh: 21.6,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: [
          {
            nm: "Animator 1",
            s: {
              t: 0,
              xe: { a: 0, k: 0, ix: 7 },
              ne: { a: 0, k: 0, ix: 8 },
              a: { a: 0, k: 100, ix: 4 },
              b: 1,
              rn: 0,
              sh: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 12,
                    s: [0],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 22,
                    s: [100],
                  },
                  { t: 74.5625, s: [100] },
                ],
                ix: 1,
              },
              r: 1,
            },
            a: { o: { a: 0, k: 0, ix: 9 } },
          },
        ],
      },
      ip: 12,
      op: 60,
      st: 18,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 5,
      nm: "TOUCH",
      parent: 29,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 16,
              s: [0],
            },
            { t: 23, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [2.778, -561.442, 0], ix: 2, l: 2 },
        a: { a: 0, k: [39.269, 0.23, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 18,
                f: "Inter-Regular",
                t: "TOUCH",
                ca: 0,
                j: 0,
                tr: 147,
                lh: 21.6,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: [
          {
            nm: "Animator 1",
            s: {
              t: 0,
              xe: { a: 0, k: 0, ix: 7 },
              ne: { a: 0, k: 0, ix: 8 },
              a: { a: 0, k: 100, ix: 4 },
              b: 1,
              rn: 0,
              sh: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 16,
                    s: [0],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 26,
                    s: [100],
                  },
                  { t: 78.5625, s: [100] },
                ],
                ix: 1,
              },
              r: 1,
            },
            a: { o: { a: 0, k: 0, ix: 9 } },
          },
        ],
      },
      ip: 16,
      op: 60,
      st: 16,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 5,
      nm: "SMELL",
      parent: 29,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 14,
              s: [0],
            },
            { t: 21, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [461.987, -334.942, 0], ix: 2, l: 2 },
        a: { a: 0, k: [36.492, 0.23, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 18,
                f: "Inter-Regular",
                t: "SMELL",
                ca: 0,
                j: 0,
                tr: 147,
                lh: 21.6,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: [
          {
            nm: "Animator 1",
            s: {
              t: 0,
              xe: { a: 0, k: 0, ix: 7 },
              ne: { a: 0, k: 0, ix: 8 },
              a: { a: 0, k: 100, ix: 4 },
              b: 1,
              rn: 0,
              sh: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 14,
                    s: [0],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 24,
                    s: [100],
                  },
                  { t: 76.5625, s: [100] },
                ],
                ix: 1,
              },
              r: 1,
            },
            a: { o: { a: 0, k: 0, ix: 9 } },
          },
        ],
      },
      ip: 14,
      op: 60,
      st: 14,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 5,
      nm: "TASTE",
      parent: 29,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 12,
              s: [0],
            },
            { t: 19, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [599.53, 3.808, 0], ix: 2, l: 2 },
        a: { a: 0, k: [34.784, 0.23, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 18,
                f: "Inter-Regular",
                t: "TASTE",
                ca: 0,
                j: 0,
                tr: 147,
                lh: 21.6,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: [
          {
            nm: "Animator 1",
            s: {
              t: 0,
              xe: { a: 0, k: 0, ix: 7 },
              ne: { a: 0, k: 0, ix: 8 },
              a: { a: 0, k: 100, ix: 4 },
              b: 1,
              rn: 0,
              sh: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 12,
                    s: [0],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 22,
                    s: [100],
                  },
                  { t: 74.5625, s: [100] },
                ],
                ix: 1,
              },
              r: 1,
            },
            a: { o: { a: 0, k: 0, ix: 9 } },
          },
        ],
      },
      ip: 12,
      op: 60,
      st: 12,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 5,
      nm: "SOCIAL EXPERIENCE",
      parent: 52,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 23,
              s: [0],
            },
            { t: 30, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [594.5, 210.607, 0], ix: 2, l: 2 },
        a: { a: 0, k: [3.504, 21.779, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 18,
                f: "Inter-Regular",
                t: "SOCIAL\rEXPERIENCE",
                ca: 0,
                j: 2,
                tr: 147,
                lh: 21.6000003814697,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: [
          {
            nm: "Animator 1",
            s: {
              t: 0,
              xe: { a: 0, k: 0, ix: 7 },
              ne: { a: 0, k: 0, ix: 8 },
              a: { a: 0, k: 100, ix: 4 },
              b: 1,
              rn: 0,
              sh: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 23,
                    s: [0],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 33,
                    s: [100],
                  },
                  { t: 85.5625, s: [100] },
                ],
                ix: 1,
              },
              r: 1,
            },
            a: { o: { a: 0, k: 0, ix: 9 } },
          },
        ],
      },
      ip: 23,
      op: 60,
      st: 23,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 5,
      nm: "SPECIALLY CURATED MUSIC for a variety of classes",
      parent: 52,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 22,
              s: [0],
            },
            { t: 29, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [449.202, 480.089, 0], ix: 2, l: 2 },
        a: { a: 0, k: [1.457, 47.261, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 18,
                f: "Inter-Regular",
                t: "SPECIALLY\rCURATED MUSIC\rfor a variety of classes",
                ca: 0,
                j: 2,
                tr: 147,
                lh: 21.6000003814697,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: [
          {
            nm: "Animator 1",
            s: {
              t: 0,
              xe: { a: 0, k: 0, ix: 7 },
              ne: { a: 0, k: 0, ix: 8 },
              a: { a: 0, k: 100, ix: 4 },
              b: 1,
              rn: 0,
              sh: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 22,
                    s: [0],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 32,
                    s: [100],
                  },
                  { t: 84.5625, s: [100] },
                ],
                ix: 1,
              },
              r: 1,
            },
            a: { o: { a: 0, k: 0, ix: 9 } },
          },
        ],
      },
      ip: 22,
      op: 60,
      st: 22,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 5,
      nm: "ASAMBA STICK",
      parent: 52,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 18,
              s: [0],
            },
            { t: 25, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-1.244, 598.658, 0], ix: 2, l: 2 },
        a: { a: 0, k: [1.402, 21.83, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 18,
                f: "Inter-Regular",
                t: "ASAMBA\rSTICK",
                ca: 0,
                j: 2,
                tr: 147,
                lh: 21.6000003814697,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: [
          {
            nm: "Animator 1",
            s: {
              t: 0,
              xe: { a: 0, k: 0, ix: 7 },
              ne: { a: 0, k: 0, ix: 8 },
              a: { a: 0, k: 100, ix: 4 },
              b: 1,
              rn: 0,
              sh: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 18,
                    s: [0],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 28,
                    s: [100],
                  },
                  { t: 80.5625, s: [100] },
                ],
                ix: 1,
              },
              r: 1,
            },
            a: { o: { a: 0, k: 0, ix: 9 } },
          },
        ],
      },
      ip: 18,
      op: 60,
      st: 25,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 5,
      nm: "CONTENT IS EVERYTHING",
      parent: 52,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 20,
              s: [0],
            },
            { t: 27, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-463.108, 433.658, 0], ix: 2, l: 2 },
        a: { a: 0, k: [1.646, 21.83, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 18,
                f: "Inter-Regular",
                t: "CONTENT\rIS EVERYTHING",
                ca: 0,
                j: 2,
                tr: 147,
                lh: 21.6000003814697,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: [
          {
            nm: "Animator 1",
            s: {
              t: 0,
              xe: { a: 0, k: 0, ix: 7 },
              ne: { a: 0, k: 0, ix: 8 },
              a: { a: 0, k: 100, ix: 4 },
              b: 1,
              rn: 0,
              sh: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 20,
                    s: [0],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 30,
                    s: [100],
                  },
                  { t: 82.5625, s: [100] },
                ],
                ix: 1,
              },
              r: 1,
            },
            a: { o: { a: 0, k: 0, ix: 9 } },
          },
        ],
      },
      ip: 20,
      op: 60,
      st: 20,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 10,
      ty: 5,
      nm: "IMMERSIVE EXPERIENCE",
      parent: 52,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 19,
              s: [0],
            },
            { t: 26, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-585.385, 210.607, 0], ix: 2, l: 2 },
        a: { a: 0, k: [1.619, 21.779, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 18,
                f: "Inter-Regular",
                t: "IMMERSIVE\rEXPERIENCE",
                ca: 0,
                j: 2,
                tr: 147,
                lh: 21.6000003814697,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: [
          {
            nm: "Animator 1",
            s: {
              t: 0,
              xe: { a: 0, k: 0, ix: 7 },
              ne: { a: 0, k: 0, ix: 8 },
              a: { a: 0, k: 100, ix: 4 },
              b: 1,
              rn: 0,
              sh: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 19,
                    s: [0],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 29,
                    s: [100],
                  },
                  { t: 81.5625, s: [100] },
                ],
                ix: 1,
              },
              r: 1,
            },
            a: { o: { a: 0, k: 0, ix: 9 } },
          },
        ],
      },
      ip: 19,
      op: 60,
      st: 19,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 11,
      ty: 5,
      nm: "WAWO FOOD OUTLET",
      parent: 52,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 18,
              s: [0],
            },
            { t: 25, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [647.278, 20.408, 0], ix: 2, l: 2 },
        a: { a: 0, k: [1.782, 21.83, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 18,
                f: "Inter-Regular",
                t: "WAWO\rFOOD OUTLET",
                ca: 0,
                j: 2,
                tr: 147,
                lh: 21.6000003814697,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: [
          {
            nm: "Animator 1",
            s: {
              t: 0,
              xe: { a: 0, k: 0, ix: 7 },
              ne: { a: 0, k: 0, ix: 8 },
              a: { a: 0, k: 100, ix: 4 },
              b: 1,
              rn: 0,
              sh: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 18,
                    s: [0],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 28,
                    s: [100],
                  },
                  { t: 80.5625, s: [100] },
                ],
                ix: 1,
              },
              r: 1,
            },
            a: { o: { a: 0, k: 0, ix: 9 } },
          },
        ],
      },
      ip: 18,
      op: 60,
      st: 18,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 12,
      ty: 5,
      nm: "THE DOME",
      parent: 52,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              t: 12,
              s: [0],
            },
            { t: 19, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-623.025, -1.243, 0], ix: 2, l: 2 },
        a: { a: 0, k: [59.479, 0.179, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 18,
                f: "Inter-Regular",
                t: "THE DOME",
                ca: 0,
                j: 0,
                tr: 147,
                lh: 21.6,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: { g: 1, a: { a: 0, k: [0, 0], ix: 2 } },
        a: [
          {
            nm: "Animator 1",
            s: {
              t: 0,
              xe: { a: 0, k: 0, ix: 7 },
              ne: { a: 0, k: 0, ix: 8 },
              a: { a: 0, k: 100, ix: 4 },
              b: 1,
              rn: 0,
              sh: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 12,
                    s: [0],
                  },
                  {
                    i: { x: [0.833], y: [0.833] },
                    o: { x: [0.167], y: [0.167] },
                    t: 22,
                    s: [100],
                  },
                  { t: 74.5625, s: [100] },
                ],
                ix: 1,
              },
              r: 1,
            },
            a: { o: { a: 0, k: 0, ix: 9 } },
          },
        ],
      },
      ip: 12,
      op: 60,
      st: 17,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 13,
      ty: 3,
      nm: "Null 1",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [961, 1017.782, 0], ix: 2, l: 2 },
        a: { a: 0, k: [50.193, 49.951, 0], ix: 1, l: 2 },
        s: { a: 0, k: [778, 446.844, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 14,
      ty: 4,
      nm: "top Circle small 6 Outlines 2",
      parent: 29,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-460.461, 0.36, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 13,
              s: [0, 0, 100],
            },
            { t: 30, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 13,
      op: 60,
      st: 13,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 15,
      ty: 4,
      nm: "top Circle small 6 Outlines",
      parent: 29,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-460.461, 0.36, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 13,
              s: [0, 0, 100],
            },
            { t: 30, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.564, 0],
                    [0, -45.563],
                    [45.563, 0],
                    [0, 45.564],
                  ],
                  o: [
                    [45.563, 0],
                    [0, 45.564],
                    [-45.564, 0],
                    [0, -45.563],
                  ],
                  v: [
                    [0, -82.5],
                    [82.5, 0],
                    [0, 82.5],
                    [-82.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 13,
      op: 60,
      st: 13,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 16,
      ty: 2,
      nm: "tc1.png",
      cl: "png",
      parent: 29,
      tt: 1,
      refId: "image_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-461, 2.578, 0], ix: 2, l: 2 },
        a: { a: 0, k: [377.5, 313.5, 0], ix: 1, l: 2 },
        s: { a: 0, k: [27.947, 27.947, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 17,
      ty: 4,
      nm: "top Circle small 5 Outlines 2",
      parent: 29,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-322.461, -336.64, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 11,
              s: [0, 0, 100],
            },
            { t: 28, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 11,
      op: 60,
      st: 11,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 18,
      ty: 4,
      nm: "top Circle small 5 Outlines",
      parent: 29,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-322.461, -336.64, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 11,
              s: [0, 0, 100],
            },
            { t: 28, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.563, 0],
                    [0, -45.563],
                    [45.563, 0],
                    [0, 45.564],
                  ],
                  o: [
                    [45.563, 0],
                    [0, 45.564],
                    [-45.563, 0],
                    [0, -45.563],
                  ],
                  v: [
                    [0, -82.5],
                    [82.5, 0],
                    [0, 82.5],
                    [-82.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 11,
      op: 60,
      st: 11,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 19,
      ty: 2,
      nm: "tc2.png",
      cl: "png",
      parent: 29,
      tt: 1,
      refId: "image_1",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-320, -336.922, 0], ix: 2, l: 2 },
        a: { a: 0, k: [748.5, 645.5, 0], ix: 1, l: 2 },
        s: { a: 0, k: [13.293, 13.293, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 20,
      ty: 4,
      nm: "top Circle small 4 Outlines 2",
      parent: 29,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [0, -454.14, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 83.25, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 9,
              s: [0, 0, 100],
            },
            { t: 26, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.563],
                    [45.287, 0],
                    [0, 45.564],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.564],
                    [-45.287, 0],
                    [0, -45.563],
                  ],
                  v: [
                    [0, -82.5],
                    [82, 0],
                    [0, 82.5],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 83.25], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 9,
      op: 60,
      st: 9,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 21,
      ty: 4,
      nm: "top Circle small 4 Outlines",
      parent: 29,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [0, -454.14, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 83.25, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 9,
              s: [0, 0, 100],
            },
            { t: 26, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.563],
                    [45.287, 0],
                    [0, 45.564],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.564],
                    [-45.287, 0],
                    [0, -45.563],
                  ],
                  v: [
                    [0, -82.5],
                    [82, 0],
                    [0, 82.5],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 83.25], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.563, 0],
                    [0, -45.84],
                    [45.563, 0],
                    [0, 45.84],
                  ],
                  o: [
                    [45.563, 0],
                    [0, 45.84],
                    [-45.563, 0],
                    [0, -45.84],
                  ],
                  v: [
                    [0, -83],
                    [82.5, 0],
                    [0, 83],
                    [-82.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 83.25], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 9,
      op: 60,
      st: 9,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 22,
      ty: 2,
      nm: "tc3.png",
      cl: "png",
      parent: 29,
      tt: 1,
      refId: "image_2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [1, -455.422, 0], ix: 2, l: 2 },
        a: { a: 0, k: [475, 469.5, 0], ix: 1, l: 2 },
        s: { a: 0, k: [18.526, 18.526, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 23,
      ty: 4,
      nm: "top Circle small 2 Outlines 2",
      parent: 29,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [324.539, -336.64, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 7,
              s: [0, 0, 100],
            },
            { t: 24, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 7,
      op: 60,
      st: 7,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 24,
      ty: 4,
      nm: "top Circle small 2 Outlines",
      parent: 29,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [324.539, -336.64, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 7,
              s: [0, 0, 100],
            },
            { t: 24, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.563, 0],
                    [0, -45.563],
                    [45.564, 0],
                    [0, 45.564],
                  ],
                  o: [
                    [45.564, 0],
                    [0, 45.564],
                    [-45.563, 0],
                    [0, -45.563],
                  ],
                  v: [
                    [0, -82.5],
                    [82.5, 0],
                    [0, 82.5],
                    [-82.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 7,
      op: 60,
      st: 7,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 25,
      ty: 2,
      nm: "tc4.png",
      cl: "png",
      parent: 29,
      tt: 1,
      refId: "image_3",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [325, -337.422, 0], ix: 2, l: 2 },
        a: { a: 0, k: [276.5, 276.5, 0], ix: 1, l: 2 },
        s: { a: 0, k: [30.561, 30.561, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 26,
      ty: 4,
      nm: "top Circle small 1 Outlines 2",
      parent: 29,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [462.539, 0.36, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 5,
              s: [0, 0, 100],
            },
            { t: 22, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 5,
      op: 60,
      st: 5,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 27,
      ty: 4,
      nm: "top Circle small 1 Outlines",
      parent: 29,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [462.539, 0.36, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 5,
              s: [0, 0, 100],
            },
            { t: 22, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.563, 0],
                    [0, -45.563],
                    [45.564, 0],
                    [0, 45.564],
                  ],
                  o: [
                    [45.564, 0],
                    [0, 45.564],
                    [-45.563, 0],
                    [0, -45.563],
                  ],
                  v: [
                    [0, -82.5],
                    [82.5, 0],
                    [0, 82.5],
                    [-82.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 5,
      op: 60,
      st: 5,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 28,
      ty: 2,
      nm: "tc5.png",
      cl: "png",
      parent: 29,
      tt: 1,
      refId: "image_4",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [462, 0.578, 0], ix: 2, l: 2 },
        a: { a: 0, k: [302.5, 302.5, 0], ix: 1, l: 2 },
        s: { a: 0, k: [28.926, 28.926, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 29,
      ty: 3,
      nm: "Null 2",
      parent: 30,
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.247], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 1,
              s: [10.2],
            },
            { t: 44, s: [0] },
          ],
          ix: 10,
        },
        p: { a: 0, k: [455.461, 456.64, 0], ix: 2, l: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 30,
      ty: 4,
      nm: "top Circle Outlines",
      parent: 13,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.167], y: [0] },
              t: -4,
              s: [1],
            },
            { t: 21, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0, y: 1 },
              o: { x: 0.333, y: 0 },
              t: -9,
              s: [50.134, -46.56, 0],
              to: [0, 7.432, 0],
              ti: [0, -7.432, 0],
            },
            { t: 40, s: [50.134, -1.969, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [456.5, 457, 0], ix: 1, l: 2 },
        s: { a: 0, k: [12.853, 22.379, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-250.461, 0],
                    [0, -250.737],
                    [250.461, 0],
                    [0, 250.737],
                  ],
                  o: [
                    [250.461, 0],
                    [0, 250.737],
                    [-250.461, 0],
                    [0, -250.737],
                  ],
                  v: [
                    [0, -454],
                    [453.5, 0],
                    [0, 454],
                    [-453.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 1, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [456.5, 457], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-250.737, 0],
                    [0, -251.013],
                    [250.737, 0],
                    [0, 251.013],
                  ],
                  o: [
                    [250.737, 0],
                    [0, 251.013],
                    [-250.737, 0],
                    [0, -251.013],
                  ],
                  v: [
                    [0, -454.5],
                    [454, 0],
                    [0, 454.5],
                    [-454, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 1, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 10,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [456.5, 457], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "tm",
          s: { a: 0, k: 0, ix: 1 },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.333], y: [0] },
                t: -4,
                s: [0],
              },
              { t: 35, s: [100] },
            ],
            ix: 2,
          },
          o: {
            a: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.005], y: [0] },
                t: 2,
                s: [-76.6],
              },
              { t: 54, s: [0] },
            ],
            ix: 3,
          },
          m: 1,
          ix: 3,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false,
        },
      ],
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 31,
      ty: 4,
      nm: "Bottom Circle small 7 Outlines 2",
      parent: 52,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [461.539, -8.64, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 13,
              s: [0, 0, 100],
            },
            { t: 30, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 13,
      op: 60,
      st: 13,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 32,
      ty: 4,
      nm: "Bottom Circle small 7 Outlines",
      parent: 52,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [461.539, -8.64, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 13,
              s: [0, 0, 100],
            },
            { t: 30, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.563, 0],
                    [0, -45.563],
                    [45.564, 0],
                    [0, 45.563],
                  ],
                  o: [
                    [45.564, 0],
                    [0, 45.563],
                    [-45.563, 0],
                    [0, -45.563],
                  ],
                  v: [
                    [0, -82.5],
                    [82.5, 0],
                    [0, 82.5],
                    [-82.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 13,
      op: 60,
      st: 13,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 33,
      ty: 2,
      nm: "bc7.png",
      cl: "png",
      parent: 52,
      tt: 1,
      refId: "image_5",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [462, -8.422, 0], ix: 2, l: 2 },
        a: { a: 0, k: [728, 728, 0], ix: 1, l: 2 },
        s: { a: 0, k: [11.538, 11.538, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 34,
      ty: 4,
      nm: "Bottom Circle small 6 Outlines 3",
      parent: 52,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [411.539, 191.36, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 12,
              s: [0, 0, 100],
            },
            { t: 29, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 12,
      op: 60,
      st: 12,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 35,
      ty: 4,
      nm: "Bottom Circle small 6 Outlines",
      parent: 52,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [411.539, 191.36, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 12,
              s: [0, 0, 100],
            },
            { t: 29, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.563, 0],
                    [0, -45.564],
                    [45.564, 0],
                    [0, 45.563],
                  ],
                  o: [
                    [45.564, 0],
                    [0, 45.563],
                    [-45.563, 0],
                    [0, -45.564],
                  ],
                  v: [
                    [0, -82.5],
                    [82.5, 0],
                    [0, 82.5],
                    [-82.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 12,
      op: 60,
      st: 12,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 36,
      ty: 2,
      nm: "bc6.png",
      cl: "png",
      parent: 52,
      tt: 1,
      refId: "image_6",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [414, 191.578, 0], ix: 2, l: 2 },
        a: { a: 0, k: [162.5, 162.5, 0], ix: 1, l: 2 },
        s: { a: 0, k: [52, 52, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 37,
      ty: 4,
      nm: "Bottom Circle small 5 Outlines 2",
      parent: 52,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [266.539, 372.36, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 11,
              s: [0, 0, 100],
            },
            { t: 28, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 11,
      op: 60,
      st: 11,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 38,
      ty: 4,
      nm: "Bottom Circle small 5 Outlines",
      parent: 52,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [266.539, 372.36, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 11,
              s: [0, 0, 100],
            },
            { t: 28, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.563, 0],
                    [0, -45.564],
                    [45.564, 0],
                    [0, 45.563],
                  ],
                  o: [
                    [45.564, 0],
                    [0, 45.563],
                    [-45.563, 0],
                    [0, -45.564],
                  ],
                  v: [
                    [0, -82.5],
                    [82.5, 0],
                    [0, 82.5],
                    [-82.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 11,
      op: 60,
      st: 11,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 39,
      ty: 2,
      nm: "bc5.png",
      cl: "png",
      parent: 52,
      tt: 1,
      refId: "image_7",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [266, 370.578, 0], ix: 2, l: 2 },
        a: { a: 0, k: [406, 403.5, 0], ix: 1, l: 2 },
        s: { a: 0, k: [22.167, 22.167, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 40,
      ty: 4,
      nm: "Bottom Circle small 4 Outlines 2",
      parent: 52,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-1, 438.86, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 83.25, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 10,
              s: [0, 0, 100],
            },
            { t: 27, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.563],
                    [45.287, 0],
                    [0, 45.563],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.563],
                    [-45.287, 0],
                    [0, -45.563],
                  ],
                  v: [
                    [0, -82.5],
                    [82, 0],
                    [0, 82.5],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 83.25], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 10,
      op: 60,
      st: 10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 41,
      ty: 4,
      nm: "Bottom Circle small 4 Outlines",
      parent: 52,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-1, 438.86, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 83.25, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 10,
              s: [0, 0, 100],
            },
            { t: 27, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.563],
                    [45.287, 0],
                    [0, 45.563],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.563],
                    [-45.287, 0],
                    [0, -45.563],
                  ],
                  v: [
                    [0, -82.5],
                    [82, 0],
                    [0, 82.5],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 83.25], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.563, 0],
                    [0, -45.84],
                    [45.563, 0],
                    [0, 45.84],
                  ],
                  o: [
                    [45.563, 0],
                    [0, 45.84],
                    [-45.563, 0],
                    [0, -45.84],
                  ],
                  v: [
                    [0, -83],
                    [82.5, 0],
                    [0, 83],
                    [-82.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 83.25], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 10,
      op: 60,
      st: 10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 42,
      ty: 2,
      nm: "bc4.png",
      cl: "png",
      parent: 52,
      tt: 1,
      refId: "image_8",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [0, 438.578, 0], ix: 2, l: 2 },
        a: { a: 0, k: [327, 327, 0], ix: 1, l: 2 },
        s: { a: 0, k: [25.994, 25.994, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 43,
      ty: 4,
      nm: "Bottom Circle small 3 Outlines 2",
      parent: 52,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-265.461, 372.36, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 8,
              s: [0, 0, 100],
            },
            { t: 25, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 8,
      op: 60,
      st: 8,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 44,
      ty: 4,
      nm: "Bottom Circle small 3 Outlines",
      parent: 52,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-265.461, 372.36, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 8,
              s: [0, 0, 100],
            },
            { t: 25, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.563, 0],
                    [0, -45.564],
                    [45.563, 0],
                    [0, 45.563],
                  ],
                  o: [
                    [45.563, 0],
                    [0, 45.563],
                    [-45.563, 0],
                    [0, -45.564],
                  ],
                  v: [
                    [0, -82.5],
                    [82.5, 0],
                    [0, 82.5],
                    [-82.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 8,
      op: 60,
      st: 8,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 45,
      ty: 2,
      nm: "bc3.png",
      cl: "png",
      parent: 52,
      tt: 1,
      refId: "image_9",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-267, 371.578, 0], ix: 2, l: 2 },
        a: { a: 0, k: [621.5, 621.5, 0], ix: 1, l: 2 },
        s: { a: 0, k: [13.918, 13.918, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 46,
      ty: 4,
      nm: "Bottom Circle small 2 Outlines 2",
      parent: 52,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-405.461, 191.36, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 6,
              s: [0, 0, 100],
            },
            { t: 23, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 1, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 6,
      op: 60,
      st: 6,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 47,
      ty: 4,
      nm: "Bottom Circle small 2 Outlines",
      parent: 52,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-405.461, 191.36, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 6,
              s: [0, 0, 100],
            },
            { t: 23, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.564, 0],
                    [0, -45.564],
                    [45.563, 0],
                    [0, 45.563],
                  ],
                  o: [
                    [45.563, 0],
                    [0, 45.563],
                    [-45.564, 0],
                    [0, -45.564],
                  ],
                  v: [
                    [0, -82.5],
                    [82.5, 0],
                    [0, 82.5],
                    [-82.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 6,
      op: 60,
      st: 6,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 48,
      ty: 2,
      nm: "bc2.png",
      cl: "png",
      parent: 52,
      tt: 1,
      refId: "image_10",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-404, 191.578, 0], ix: 2, l: 2 },
        a: { a: 0, k: [644, 644, 0], ix: 1, l: 2 },
        s: { a: 0, k: [14.286, 14.286, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 49,
      ty: 4,
      nm: "Bottom Circle small 1 Outlines 2",
      parent: 52,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-461.461, -8.64, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 5,
              s: [0, 0, 100],
            },
            { t: 22, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 1,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "st",
          c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
          o: { a: 0, k: 100, ix: 4 },
          w: { a: 0, k: 1, ix: 5 },
          lc: 1,
          lj: 1,
          ml: 4,
          bm: 0,
          nm: "Stroke 1",
          mn: "ADBE Vector Graphic - Stroke",
          hd: false,
        },
      ],
      ip: 5,
      op: 60,
      st: 5,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 50,
      ty: 4,
      nm: "Bottom Circle small 1 Outlines",
      parent: 52,
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-461.461, -8.64, 0], ix: 2, l: 2 },
        a: { a: 0, k: [82.75, 82.75, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 5,
              s: [0, 0, 100],
            },
            { t: 22, s: [100, 100, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.287, 0],
                    [0, -45.287],
                    [45.287, 0],
                    [0, 45.287],
                  ],
                  o: [
                    [45.287, 0],
                    [0, 45.287],
                    [-45.287, 0],
                    [0, -45.287],
                  ],
                  v: [
                    [0, -82],
                    [82, 0],
                    [0, 82],
                    [-82, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-45.564, 0],
                    [0, -45.563],
                    [45.563, 0],
                    [0, 45.563],
                  ],
                  o: [
                    [45.563, 0],
                    [0, 45.563],
                    [-45.564, 0],
                    [0, -45.563],
                  ],
                  v: [
                    [0, -82.5],
                    [82.5, 0],
                    [0, 82.5],
                    [-82.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [82.75, 82.75], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 5,
      op: 60,
      st: 5,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 51,
      ty: 2,
      nm: "bc1.png",
      cl: "png",
      parent: 52,
      tt: 1,
      refId: "image_11",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [-460, -10.422, 0], ix: 2, l: 2 },
        a: { a: 0, k: [235.5, 235.5, 0], ix: 1, l: 2 },
        s: { a: 0, k: [38.004, 38.004, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 52,
      ty: 3,
      nm: "Null 3",
      parent: 53,
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.363], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 0,
              s: [14],
            },
            { t: 44, s: [0] },
          ],
          ix: 10,
        },
        p: { a: 0, k: [456.461, 456.64, 0], ix: 2, l: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 53,
      ty: 4,
      nm: "Bottom Circle Outlines",
      parent: 13,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: -5,
              s: [0],
            },
            { t: 21, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0, y: 1 },
              o: { x: 0.333, y: 0 },
              t: -9,
              s: [50.134, 169.008, 0],
              to: [0, -11.19, 0],
              ti: [0, 11.19, 0],
            },
            { t: 40, s: [50.134, 101.871, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [456.5, 457, 0], ix: 1, l: 2 },
        s: { a: 0, k: [12.853, 22.379, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-250.461, 0],
                    [0, -250.737],
                    [250.461, 0],
                    [0, 250.737],
                  ],
                  o: [
                    [250.461, 0],
                    [0, 250.737],
                    [-250.461, 0],
                    [0, -250.737],
                  ],
                  v: [
                    [0, -454],
                    [453.5, 0],
                    [0, 454],
                    [-453.5, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 1, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [456.5, 457], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-250.737, 0],
                    [0, -251.013],
                    [250.737, 0],
                    [0, 251.013],
                  ],
                  o: [
                    [250.737, 0],
                    [0, 251.013],
                    [-250.737, 0],
                    [0, -251.013],
                  ],
                  v: [
                    [0, -454.5],
                    [454, 0],
                    [0, 454.5],
                    [-454, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "st",
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 1, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 10,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [456.5, 457], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "tm",
          s: { a: 0, k: 0, ix: 1 },
          e: {
            a: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.333], y: [0] },
                t: -4,
                s: [0],
              },
              { t: 35, s: [100] },
            ],
            ix: 2,
          },
          o: {
            a: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.005], y: [0] },
                t: -4,
                s: [67],
              },
              { t: 58, s: [180] },
            ],
            ix: 3,
          },
          m: 1,
          ix: 3,
          nm: "Trim Paths 1",
          mn: "ADBE Vector Filter - Trim",
          hd: false,
        },
      ],
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 54,
      ty: 4,
      nm: "Central mask ",
      parent: 13,
      td: 1,
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            { i: { x: [0], y: [1] }, o: { x: [0.333], y: [0] }, t: 4, s: [0] },
            { t: 34, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 0.643 },
              o: { x: 0.333, y: 0 },
              t: 5,
              s: [50.193, 53.532, 0],
              to: [0, -0.056, 0],
              ti: [0, 0.288, 0],
            },
            {
              i: { x: 0.665, y: 0.942 },
              o: { x: 0.315, y: 0.29 },
              t: 12,
              s: [50.193, 51.956, 0],
              to: [0, -0.076, 0],
              ti: [0, 0.051, 0],
            },
            {
              i: { x: 0.762, y: 0 },
              o: { x: 0.374, y: 0.121 },
              t: 14,
              s: [50.193, 51.432, 0],
              to: [0, -0.33, 0],
              ti: [0, 0.211, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.099, y: 1 },
              t: 16,
              s: [50.193, 51.35, 0],
              to: [0, -0.95, 0],
              ti: [0, 0.43, 0],
            },
            { t: 40, s: [50.193, 49.951, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [390.14, 222.25, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.007, 0.007, 0.333], y: [0, 0, 0] },
              t: 5,
              s: [9.83, 10.902, 100],
            },
            { t: 40, s: [12.853, 22.379, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [165.787, 0],
                    [79.099, -132.937],
                    [-165.787, 0],
                    [-79.099, 132.937],
                  ],
                  o: [
                    [-165.787, 0],
                    [79.099, 132.937],
                    [165.787, 0],
                    [-79.099, -132.937],
                  ],
                  v: [
                    [0, -222],
                    [-389.89, 0],
                    [0, 222],
                    [389.89, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [1, 1, 1, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [390.14, 222.25], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 55,
      ty: 2,
      nm: "middle image.png",
      cl: "png",
      tt: 1,
      refId: "image_12",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [959.5, 927, 0], ix: 2, l: 2 },
        a: { a: 0, k: [436.5, 235.5, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: -2,
              s: [223, 223, 100],
            },
            { t: 32, s: [136, 136, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 60,
      st: -10,
      bm: 0,
    },
  ],
  markers: [],
  chars: [
    {
      ch: "T",
      size: 18,
      style: "Regular",
      w: 64.2,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [27.699, -64.915],
                      [27.699, 0],
                      [36.506, 0],
                      [36.506, -64.915],
                      [59.375, -64.915],
                      [59.375, -72.727],
                      [4.83, -72.727],
                      [4.83, -64.915],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "T",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "T",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "H",
      size: 18,
      style: "Regular",
      w: 74.01,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [17.614, 0],
                      [17.614, -32.528],
                      [56.392, -32.528],
                      [56.392, 0],
                      [65.199, 0],
                      [65.199, -72.727],
                      [56.392, -72.727],
                      [56.392, -40.341],
                      [17.614, -40.341],
                      [17.614, -72.727],
                      [8.807, -72.727],
                      [8.807, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "H",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "H",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "E",
      size: 18,
      style: "Regular",
      w: 59.8,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [53.267, 0],
                      [53.267, -7.812],
                      [17.614, -7.812],
                      [17.614, -32.528],
                      [50.426, -32.528],
                      [50.426, -40.341],
                      [17.614, -40.341],
                      [17.614, -64.915],
                      [52.699, -64.915],
                      [52.699, -72.727],
                      [8.807, -72.727],
                      [8.807, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "E",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "E",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: " ",
      size: 18,
      style: "Regular",
      w: 28.12,
      data: {},
      fFamily: "Inter",
    },
    {
      ch: "D",
      size: 18,
      style: "Regular",
      w: 71.88,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-5.161, 2.924],
                      [-2.699, 5.457],
                      [0, 7.576],
                      [2.675, 5.41],
                      [5.019, 2.9],
                      [7.055, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [5.161, -2.924],
                      [2.699, -5.457],
                      [0, -7.528],
                      [-2.676, -5.409],
                      [-5.019, -2.9],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [7.386, 0],
                    ],
                    v: [
                      [50.071, -4.386],
                      [61.861, -16.957],
                      [65.909, -36.506],
                      [61.896, -55.913],
                      [50.355, -68.377],
                      [32.244, -72.727],
                      [8.807, -72.727],
                      [8.807, 0],
                      [31.25, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "D",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [-3.812, -2.284],
                      [-1.918, -4.249],
                      [0, -5.871],
                      [1.941, -4.285],
                      [3.953, -2.32],
                      [6.013, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [5.682, 0],
                      [3.811, 2.285],
                      [1.918, 4.25],
                      [0, 5.919],
                      [-1.941, 4.285],
                      [-3.954, 2.32],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [17.614, -64.915],
                      [31.676, -64.915],
                      [45.916, -61.488],
                      [54.51, -51.687],
                      [57.386, -36.506],
                      [54.474, -21.2],
                      [45.632, -11.293],
                      [30.682, -7.812],
                      [17.614, -7.812],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "D",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "D",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "O",
      size: 18,
      style: "Regular",
      w: 76.14,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [2.77, 5.587],
                      [4.83, 3.031],
                      [6.202, 0],
                      [4.83, -3.03],
                      [2.77, -5.587],
                      [0, -7.67],
                      [-2.77, -5.587],
                      [-4.83, -3.03],
                      [-6.203, 0],
                      [-4.83, 3.031],
                      [-2.77, 5.587],
                      [0, 7.67],
                    ],
                    o: [
                      [-2.77, -5.587],
                      [-4.83, -3.03],
                      [-6.203, 0],
                      [-4.83, 3.031],
                      [-2.77, 5.587],
                      [0, 7.67],
                      [2.77, 5.587],
                      [4.83, 3.031],
                      [6.202, 0],
                      [4.83, -3.03],
                      [2.77, -5.587],
                      [0, -7.67],
                    ],
                    v: [
                      [66.016, -56.25],
                      [54.616, -69.176],
                      [38.068, -73.722],
                      [21.52, -69.176],
                      [10.121, -56.25],
                      [5.966, -36.364],
                      [10.121, -16.477],
                      [21.52, -3.551],
                      [38.068, 0.994],
                      [54.616, -3.551],
                      [66.016, -16.477],
                      [70.17, -36.364],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "O",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [2.095, -4.332],
                      [3.563, -2.225],
                      [4.403, 0],
                      [3.563, 2.226],
                      [2.095, 4.332],
                      [0, 6.298],
                      [-2.095, 4.332],
                      [-3.563, 2.226],
                      [-4.403, 0],
                      [-3.563, -2.225],
                      [-2.095, -4.332],
                      [0, -6.297],
                    ],
                    o: [
                      [-2.095, 4.332],
                      [-3.563, 2.226],
                      [-4.403, 0],
                      [-3.563, -2.225],
                      [-2.095, -4.332],
                      [0, -6.297],
                      [2.095, -4.332],
                      [3.563, -2.225],
                      [4.403, 0],
                      [3.563, 2.226],
                      [2.095, 4.332],
                      [0, 6.298],
                    ],
                    v: [
                      [58.505, -20.419],
                      [50.018, -10.582],
                      [38.068, -7.244],
                      [26.119, -10.582],
                      [17.631, -20.419],
                      [14.489, -36.364],
                      [17.631, -52.308],
                      [26.119, -62.145],
                      [38.068, -65.483],
                      [50.018, -62.145],
                      [58.505, -52.308],
                      [61.648, -36.364],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "O",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "O",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "M",
      size: 18,
      style: "Regular",
      w: 88.92,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [8.807, 0],
                      [17.045, 0],
                      [17.045, -55.256],
                      [17.756, -55.256],
                      [40.483, 0],
                      [48.438, 0],
                      [71.165, -55.256],
                      [71.875, -55.256],
                      [71.875, 0],
                      [80.114, 0],
                      [80.114, -72.727],
                      [69.602, -72.727],
                      [44.886, -12.358],
                      [44.034, -12.358],
                      [19.318, -72.727],
                      [8.807, -72.727],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "M",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "M",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "W",
      size: 18,
      style: "Regular",
      w: 94.89,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [31.108, 0],
                      [47.159, -57.955],
                      [47.727, -57.955],
                      [63.778, 0],
                      [72.869, 0],
                      [92.756, -72.727],
                      [83.807, -72.727],
                      [68.608, -13.494],
                      [67.898, -13.494],
                      [52.415, -72.727],
                      [42.472, -72.727],
                      [26.989, -13.494],
                      [26.278, -13.494],
                      [11.08, -72.727],
                      [2.131, -72.727],
                      [22.017, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "W",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "W",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "A",
      size: 18,
      style: "Regular",
      w: 67.61,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.523, -61.222],
                      [34.091, -61.222],
                      [55.824, 0],
                      [65.057, 0],
                      [38.352, -72.727],
                      [29.261, -72.727],
                      [2.557, 0],
                      [11.79, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "A",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.199, -20.597],
                      [52.415, -20.597],
                      [52.415, -28.409],
                      [15.199, -28.409],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "A",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "A",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    { ch: "\r", size: 18, style: "Regular", w: 0, fFamily: "Inter" },
    {
      ch: "F",
      size: 18,
      style: "Regular",
      w: 58.66,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [17.614, 0],
                      [17.614, -32.528],
                      [49.148, -32.528],
                      [49.148, -40.341],
                      [17.614, -40.341],
                      [17.614, -64.915],
                      [52.415, -64.915],
                      [52.415, -72.727],
                      [8.807, -72.727],
                      [8.807, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "F",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "F",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "U",
      size: 18,
      style: "Regular",
      w: 74.15,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [1.55, -2.758],
                      [2.912, -1.574],
                      [4.048, 0],
                      [2.9, 1.575],
                      [1.562, 2.758],
                      [0, 3.551],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-2.332, -3.894],
                      [-4.238, -2.237],
                      [-5.706, 0],
                      [-4.238, 2.237],
                      [-2.332, 3.895],
                      [0, 4.972],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 3.551],
                      [-1.551, 2.758],
                      [-2.912, 1.575],
                      [-4.048, 0],
                      [-2.9, -1.574],
                      [-1.562, -2.758],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 4.972],
                      [2.332, 3.895],
                      [4.238, 2.237],
                      [5.705, 0],
                      [4.238, -2.237],
                      [2.332, -3.894],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [56.534, -25.284],
                      [54.208, -15.82],
                      [47.514, -9.322],
                      [37.074, -6.96],
                      [26.651, -9.322],
                      [19.957, -15.82],
                      [17.614, -25.284],
                      [17.614, -72.727],
                      [8.807, -72.727],
                      [8.807, -24.574],
                      [12.305, -11.275],
                      [22.159, -2.077],
                      [37.074, 1.278],
                      [51.989, -2.077],
                      [61.843, -11.275],
                      [65.341, -24.574],
                      [65.341, -72.727],
                      [56.534, -72.727],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "U",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "U",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "L",
      size: 18,
      style: "Regular",
      w: 56.25,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [51.42, 0],
                      [51.42, -7.812],
                      [17.614, -7.812],
                      [17.614, -72.727],
                      [8.807, -72.727],
                      [8.807, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "L",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "L",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "I",
      size: 18,
      style: "Regular",
      w: 26.42,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [8.807, -72.727],
                      [8.807, 0],
                      [17.614, 0],
                      [17.614, -72.727],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "I",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "I",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "R",
      size: 18,
      style: "Regular",
      w: 63.92,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-2.391, -1.195],
                      [-1.089, -2.178],
                      [0, -2.912],
                      [1.077, -2.095],
                      [2.379, -1.136],
                      [3.882, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-3.622, 1.882],
                      [-1.752, 3.315],
                      [0, 4.285],
                      [1.752, 3.362],
                      [3.645, 1.93],
                      [5.682, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [3.93, 0],
                      [2.391, 1.196],
                      [1.089, 2.178],
                      [0, 2.912],
                      [-1.078, 2.095],
                      [-2.379, 1.136],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [5.634, 0],
                      [3.622, -1.882],
                      [1.752, -3.314],
                      [0, -4.285],
                      [-1.752, -3.361],
                      [-3.646, -1.929],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [17.614, 0],
                      [17.614, -64.915],
                      [33.097, -64.915],
                      [42.578, -63.121],
                      [47.798, -58.061],
                      [49.432, -50.426],
                      [47.816, -42.915],
                      [42.631, -38.068],
                      [33.239, -36.364],
                      [13.636, -36.364],
                      [13.636, -28.409],
                      [33.523, -28.409],
                      [47.408, -31.232],
                      [55.469, -39.027],
                      [58.097, -50.426],
                      [55.469, -61.896],
                      [47.372, -69.833],
                      [33.381, -72.727],
                      [8.807, -72.727],
                      [8.807, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "R",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [33.097, -32.67],
                      [50.71, 0],
                      [60.938, 0],
                      [43.04, -32.67],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "R",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "R",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "S",
      size: 18,
      style: "Regular",
      w: 63.78,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [2.142, 2.889],
                      [3.645, 1.669],
                      [4.688, 0],
                      [3.752, -1.692],
                      [2.213, -3.042],
                      [0, -4.072],
                      [-3.315, -3.03],
                      [-5.682, -1.634],
                      [0, 0],
                      [-2.202, -0.947],
                      [-1.349, -1.515],
                      [0, -2.415],
                      [1.562, -1.976],
                      [2.675, -1.101],
                      [3.361, 0],
                      [2.497, 0.864],
                      [1.621, 1.788],
                      [0.236, 2.747],
                      [0, 0],
                      [-2.166, -3.006],
                      [-3.8, -1.681],
                      [-5.209, 0],
                      [-3.918, 1.87],
                      [-2.048, 3.173],
                      [0, 3.93],
                      [1.397, 2.344],
                      [2.142, 1.504],
                      [2.332, 0.876],
                      [1.894, 0.497],
                      [0, 0],
                      [1.61, 0.58],
                      [1.468, 0.912],
                      [0.935, 1.385],
                      [0, 1.941],
                      [-1.338, 1.823],
                      [-2.403, 1.042],
                      [-3.22, 0],
                      [-3.031, -1.989],
                      [-0.426, -3.598],
                    ],
                    o: [
                      [-0.119, -3.669],
                      [-2.143, -2.888],
                      [-3.646, -1.669],
                      [-4.64, 0],
                      [-3.753, 1.693],
                      [-2.214, 3.042],
                      [0, 4.901],
                      [3.314, 3.031],
                      [0, 0],
                      [2.557, 0.71],
                      [2.202, 0.947],
                      [1.349, 1.515],
                      [0, 2.652],
                      [-1.562, 1.977],
                      [-2.676, 1.101],
                      [-2.889, 0],
                      [-2.498, -0.864],
                      [-1.622, -1.787],
                      [0, 0],
                      [0.284, 3.977],
                      [2.166, 3.007],
                      [3.8, 1.681],
                      [5.587, 0],
                      [3.918, -1.87],
                      [2.047, -3.172],
                      [0, -3.409],
                      [-1.397, -2.344],
                      [-2.143, -1.503],
                      [-2.332, -0.876],
                      [0, 0],
                      [-1.349, -0.355],
                      [-1.61, -0.58],
                      [-1.468, -0.911],
                      [-0.936, -1.385],
                      [0, -2.32],
                      [1.337, -1.823],
                      [2.403, -1.041],
                      [4.403, 0],
                      [3.03, 1.989],
                      [0, 0],
                    ],
                    v: [
                      [57.102, -54.545],
                      [53.711, -64.382],
                      [45.028, -71.218],
                      [32.528, -73.722],
                      [19.94, -71.183],
                      [10.991, -64.08],
                      [7.67, -53.409],
                      [12.642, -41.513],
                      [26.136, -34.517],
                      [35.085, -31.96],
                      [42.223, -29.474],
                      [47.55, -25.781],
                      [49.574, -19.886],
                      [47.23, -12.944],
                      [40.874, -8.327],
                      [31.818, -6.676],
                      [23.739, -7.972],
                      [17.56, -11.95],
                      [14.773, -18.75],
                      [5.682, -18.75],
                      [9.357, -8.274],
                      [18.306, -1.243],
                      [31.818, 1.278],
                      [46.076, -1.527],
                      [55.025, -9.091],
                      [58.097, -19.744],
                      [56.001, -28.374],
                      [50.692, -34.144],
                      [43.981, -37.713],
                      [37.642, -39.773],
                      [30.256, -41.761],
                      [25.817, -43.164],
                      [21.2, -45.401],
                      [17.596, -48.846],
                      [16.193, -53.835],
                      [18.2, -60.05],
                      [23.81, -64.347],
                      [32.244, -65.909],
                      [43.395, -62.926],
                      [48.58, -54.545],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "S",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "S",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "V",
      size: 18,
      style: "Regular",
      w: 67.61,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.557, -72.727],
                      [29.261, 0],
                      [38.352, 0],
                      [65.057, -72.727],
                      [55.824, -72.727],
                      [34.233, -11.506],
                      [33.381, -11.506],
                      [11.79, -72.727],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "V",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "V",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "X",
      size: 18,
      style: "Regular",
      w: 64.2,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.699, -72.727],
                      [26.136, -36.364],
                      [2.699, 0],
                      [13.068, 0],
                      [31.818, -29.688],
                      [32.386, -29.688],
                      [51.136, 0],
                      [61.506, 0],
                      [38.636, -36.364],
                      [61.506, -72.727],
                      [51.136, -72.727],
                      [32.386, -42.472],
                      [31.818, -42.472],
                      [13.068, -72.727],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "X",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "X",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "P",
      size: 18,
      style: "Regular",
      w: 63.49,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-2.391, -1.314],
                      [-1.078, -2.296],
                      [0, -2.912],
                      [1.077, -2.308],
                      [2.367, -1.349],
                      [3.906, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-3.622, 2.072],
                      [-1.74, 3.504],
                      [0, 4.285],
                      [1.752, 3.48],
                      [3.634, 2.048],
                      [5.705, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [3.953, 0],
                      [2.391, 1.314],
                      [1.077, 2.297],
                      [0, 2.912],
                      [-1.078, 2.308],
                      [-2.368, 1.349],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [5.658, 0],
                      [3.622, -2.071],
                      [1.74, -3.503],
                      [0, -4.285],
                      [-1.752, -3.48],
                      [-3.634, -2.047],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [17.614, 0],
                      [17.614, -64.915],
                      [33.097, -64.915],
                      [42.614, -62.944],
                      [47.816, -57.528],
                      [49.432, -49.716],
                      [47.816, -41.886],
                      [42.649, -36.399],
                      [33.239, -34.375],
                      [15.909, -34.375],
                      [15.909, -26.562],
                      [33.523, -26.562],
                      [47.443, -29.67],
                      [55.487, -38.033],
                      [58.097, -49.716],
                      [55.469, -61.364],
                      [47.39, -69.656],
                      [33.381, -72.727],
                      [8.807, -72.727],
                      [8.807, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "P",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "P",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "N",
      size: 18,
      style: "Regular",
      w: 75.28,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [57.812, -72.727],
                      [57.812, -15.483],
                      [57.102, -15.483],
                      [17.33, -72.727],
                      [8.807, -72.727],
                      [8.807, 0],
                      [17.614, 0],
                      [17.614, -57.102],
                      [18.324, -57.102],
                      [57.955, 0],
                      [66.477, 0],
                      [66.477, -72.727],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "N",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "N",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "C",
      size: 18,
      style: "Regular",
      w: 72.73,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [1.752, 2.924],
                      [2.604, 2.048],
                      [3.232, 1.065],
                      [3.669, 0],
                      [4.83, -3.03],
                      [2.77, -5.587],
                      [0, -7.67],
                      [-2.77, -5.587],
                      [-4.83, -3.03],
                      [-6.203, 0],
                      [-3.232, 1.065],
                      [-2.605, 2.048],
                      [-1.752, 2.936],
                      [-0.663, 3.717],
                      [0, 0],
                      [1.29, -1.929],
                      [1.834, -1.314],
                      [2.225, -0.663],
                      [2.415, 0],
                      [3.563, 2.226],
                      [2.095, 4.332],
                      [0, 6.298],
                      [-2.095, 4.332],
                      [-3.563, 2.226],
                      [-4.403, 0],
                      [-2.226, -0.663],
                      [-1.835, -1.314],
                      [-1.291, -1.918],
                      [-0.521, -2.533],
                      [0, 0],
                    ],
                    o: [
                      [-1.752, -2.924],
                      [-2.605, -2.047],
                      [-3.232, -1.065],
                      [-6.203, 0],
                      [-4.83, 3.031],
                      [-2.77, 5.587],
                      [0, 7.67],
                      [2.77, 5.587],
                      [4.83, 3.031],
                      [3.669, 0],
                      [3.232, -1.065],
                      [2.604, -2.047],
                      [1.752, -2.935],
                      [0, 0],
                      [-0.521, 2.51],
                      [-1.291, 1.93],
                      [-1.835, 1.314],
                      [-2.226, 0.663],
                      [-4.403, 0],
                      [-3.563, -2.225],
                      [-2.095, -4.332],
                      [0, -6.297],
                      [2.095, -4.332],
                      [3.563, -2.225],
                      [2.415, 0],
                      [2.225, 0.663],
                      [1.834, 1.314],
                      [1.29, 1.918],
                      [0, 0],
                      [-0.663, -3.74],
                    ],
                    v: [
                      [63.707, -59.996],
                      [57.173, -67.454],
                      [48.42, -72.124],
                      [38.068, -73.722],
                      [21.52, -69.176],
                      [10.121, -56.25],
                      [5.966, -36.364],
                      [10.121, -16.477],
                      [21.52, -3.551],
                      [38.068, 0.994],
                      [48.42, -0.604],
                      [57.173, -5.273],
                      [63.707, -12.749],
                      [67.33, -22.727],
                      [58.523, -22.727],
                      [55.806, -16.069],
                      [51.119, -11.204],
                      [45.028, -8.239],
                      [38.068, -7.244],
                      [26.119, -10.582],
                      [17.631, -20.419],
                      [14.489, -36.364],
                      [17.631, -52.308],
                      [26.119, -62.145],
                      [38.068, -65.483],
                      [45.028, -64.489],
                      [51.119, -61.523],
                      [55.806, -56.676],
                      [58.523, -50],
                      [67.33, -50],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "C",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "C",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "Y",
      size: 18,
      style: "Regular",
      w: 66.48,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [28.835, -29.972],
                      [28.835, 0],
                      [37.642, 0],
                      [37.642, -29.972],
                      [63.92, -72.727],
                      [53.835, -72.727],
                      [33.665, -38.778],
                      [32.812, -38.778],
                      [12.642, -72.727],
                      [2.557, -72.727],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "Y",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "Y",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "G",
      size: 18,
      style: "Regular",
      w: 74.29,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [1.752, 2.9],
                      [2.616, 2.095],
                      [3.326, 1.149],
                      [3.835, 0],
                      [3.882, -1.728],
                      [2.841, -3.243],
                      [1.55, -4.604],
                      [0, -5.753],
                      [-2.711, -5.587],
                      [-4.865, -3.03],
                      [-6.44, 0],
                      [-4.463, 2.427],
                      [-2.545, 4.427],
                      [0, 5.99],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.787, -3.279],
                      [3.184, -1.787],
                      [4.166, 0],
                      [3.598, 2.226],
                      [2.107, 4.332],
                      [0, 6.298],
                      [-2.084, 4.332],
                      [-3.528, 2.226],
                      [-4.309, 0],
                      [-2.202, -0.71],
                      [-1.74, -1.349],
                      [-1.267, -1.905],
                      [-0.781, -2.391],
                    ],
                    o: [
                      [-0.663, -3.527],
                      [-1.752, -2.9],
                      [-2.616, -2.095],
                      [-3.326, -1.148],
                      [-4.664, 0],
                      [-3.883, 1.728],
                      [-2.841, 3.244],
                      [-1.551, 4.605],
                      [0, 7.67],
                      [2.711, 5.587],
                      [4.865, 3.031],
                      [5.776, 0],
                      [4.462, -2.426],
                      [2.545, -4.427],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 4.451],
                      [-1.788, 3.279],
                      [-3.184, 1.788],
                      [-4.498, 0],
                      [-3.599, -2.225],
                      [-2.107, -4.332],
                      [0, -6.297],
                      [2.083, -4.332],
                      [3.527, -2.225],
                      [2.628, 0],
                      [2.202, 0.71],
                      [1.74, 1.349],
                      [1.266, 1.906],
                      [0, 0],
                    ],
                    v: [
                      [67.614, -50],
                      [63.991, -59.641],
                      [57.44, -67.134],
                      [48.526, -71.999],
                      [37.784, -73.722],
                      [24.964, -71.129],
                      [14.879, -63.672],
                      [8.292, -51.9],
                      [5.966, -36.364],
                      [10.032, -16.477],
                      [21.396, -3.551],
                      [38.352, 0.994],
                      [53.711, -2.646],
                      [64.222, -12.926],
                      [68.04, -28.551],
                      [68.04, -36.364],
                      [40.341, -36.364],
                      [40.341, -28.551],
                      [62.216, -28.551],
                      [59.517, -29.119],
                      [56.836, -17.525],
                      [49.379, -9.925],
                      [38.352, -7.244],
                      [26.207, -10.582],
                      [17.649, -20.419],
                      [14.489, -36.364],
                      [17.614, -52.308],
                      [26.03, -62.145],
                      [37.784, -65.483],
                      [45.028, -64.418],
                      [50.941, -61.328],
                      [55.451, -56.445],
                      [58.523, -50],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "G",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "G",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "B",
      size: 18,
      style: "Regular",
      w: 65.06,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-3.575, 1.705],
                      [-1.657, 2.912],
                      [0, 3.646],
                      [1.515, 2.652],
                      [2.249, 1.42],
                      [2.225, 0.142],
                      [0, 0],
                      [-1.788, 1.184],
                      [-1.101, 2.036],
                      [0, 3.125],
                      [1.61, 2.924],
                      [3.29, 1.74],
                      [5.066, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [5.729, 0],
                      [3.574, -1.705],
                      [1.657, -2.912],
                      [0, -3.835],
                      [-1.515, -2.651],
                      [-2.249, -1.42],
                      [0, 0],
                      [2.083, -0.568],
                      [1.787, -1.184],
                      [1.101, -2.036],
                      [0, -3.551],
                      [-1.61, -2.924],
                      [-3.291, -1.74],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [35.085, 0],
                      [49.041, -2.557],
                      [56.889, -9.482],
                      [59.375, -19.318],
                      [57.102, -29.048],
                      [51.456, -35.156],
                      [44.744, -37.5],
                      [44.744, -38.21],
                      [50.55, -40.838],
                      [54.883, -45.668],
                      [56.534, -53.409],
                      [54.119, -63.121],
                      [46.768, -70.117],
                      [34.233, -72.727],
                      [8.807, -72.727],
                      [8.807, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "B",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [-2.32, -1.266],
                      [-1.255, -2.095],
                      [0, -2.462],
                      [2.426, -2.237],
                      [5.753, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [3.172, 0],
                      [2.32, 1.267],
                      [1.255, 2.095],
                      [0, 3.196],
                      [-2.427, 2.237],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [17.614, -33.097],
                      [35.511, -33.097],
                      [43.75, -31.197],
                      [49.112, -26.154],
                      [50.994, -19.318],
                      [47.354, -11.168],
                      [35.085, -7.812],
                      [17.614, -7.812],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "B",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 2,
                ty: "sh",
                ix: 3,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [-2.226, -2.237],
                      [0, -3.196],
                      [1.266, -1.894],
                      [2.142, -1.041],
                      [2.651, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [4.83, 0],
                      [2.225, 2.237],
                      [0, 2.557],
                      [-1.267, 1.894],
                      [-2.143, 1.042],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [17.614, -64.915],
                      [34.233, -64.915],
                      [44.815, -61.559],
                      [48.153, -53.409],
                      [46.254, -46.733],
                      [41.14, -42.33],
                      [33.949, -40.767],
                      [17.614, -40.767],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "B",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "B",
            np: 6,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "K",
      size: 18,
      style: "Regular",
      w: 65.2,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [17.614, 0],
                      [17.614, -23.58],
                      [26.705, -33.807],
                      [51.989, 0],
                      [62.642, 0],
                      [32.102, -39.915],
                      [62.642, -72.727],
                      [51.136, -72.727],
                      [18.466, -36.648],
                      [17.614, -36.648],
                      [17.614, -72.727],
                      [8.807, -72.727],
                      [8.807, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "K",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "K",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "f",
      size: 18,
      style: "Regular",
      w: 36.08,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.557, -54.545],
                      [2.557, -47.443],
                      [31.96, -47.443],
                      [31.96, -54.545],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "f",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [-1.22, 1.397],
                      [-2.77, 0],
                      [-0.746, -0.213],
                      [-0.426, -0.142],
                      [0, 0],
                      [1.302, 0.332],
                      [2.06, 0],
                      [2.344, -1.041],
                      [1.468, -2.083],
                      [0, -3.125],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -2.699],
                      [1.219, -1.397],
                      [1.207, 0],
                      [0.746, 0.213],
                      [0, 0],
                      [-0.639, -0.284],
                      [-1.302, -0.331],
                      [-2.605, 0],
                      [-2.344, 1.042],
                      [-1.468, 2.084],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [19.744, 0],
                      [19.744, -60.085],
                      [21.573, -66.229],
                      [27.557, -68.324],
                      [30.487, -68.004],
                      [32.244, -67.472],
                      [34.659, -74.716],
                      [31.747, -75.639],
                      [26.705, -76.136],
                      [19.283, -74.574],
                      [13.565, -69.886],
                      [11.364, -62.074],
                      [11.364, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "f",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "f",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "o",
      size: 18,
      style: "Regular",
      w: 59.66,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-3.705, 2.344],
                      [-2.072, 4.214],
                      [0, 5.635],
                      [2.071, 4.238],
                      [3.705, 2.344],
                      [4.924, 0],
                      [3.705, -2.344],
                      [2.071, -4.238],
                      [0, -5.682],
                      [-2.072, -4.214],
                      [-3.705, -2.344],
                      [-4.924, 0],
                    ],
                    o: [
                      [3.705, -2.344],
                      [2.071, -4.214],
                      [0, -5.682],
                      [-2.072, -4.238],
                      [-3.705, -2.344],
                      [-4.924, 0],
                      [-3.705, 2.344],
                      [-2.072, 4.238],
                      [0, 5.635],
                      [2.071, 4.214],
                      [3.705, 2.344],
                      [4.924, 0],
                    ],
                    v: [
                      [42.773, -2.379],
                      [51.438, -12.216],
                      [54.545, -26.989],
                      [51.438, -41.868],
                      [42.773, -51.74],
                      [29.83, -55.256],
                      [16.886, -51.74],
                      [8.221, -41.868],
                      [5.114, -26.989],
                      [8.221, -12.216],
                      [16.886, -2.379],
                      [29.83, 1.136],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "o",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [2.415, 1.918],
                      [1.16, 3.125],
                      [0, 3.646],
                      [-1.16, 3.149],
                      [-2.415, 1.941],
                      [-3.741, 0],
                      [-2.415, -1.941],
                      [-1.16, -3.148],
                      [0, -3.645],
                      [1.16, -3.125],
                      [2.415, -1.918],
                      [3.74, 0],
                    ],
                    o: [
                      [-2.415, -1.918],
                      [-1.16, -3.125],
                      [0, -3.645],
                      [1.16, -3.148],
                      [2.415, -1.941],
                      [3.74, 0],
                      [2.415, 1.941],
                      [1.16, 3.149],
                      [0, 3.646],
                      [-1.16, 3.125],
                      [-2.415, 1.918],
                      [-3.741, 0],
                    ],
                    v: [
                      [20.597, -9.268],
                      [15.234, -16.832],
                      [13.494, -26.989],
                      [15.234, -37.18],
                      [20.597, -44.815],
                      [29.83, -47.727],
                      [39.062, -44.815],
                      [44.425, -37.18],
                      [46.165, -26.989],
                      [44.425, -16.832],
                      [39.062, -9.268],
                      [29.83, -6.392],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "o",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "o",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "r",
      size: 18,
      style: "Regular",
      w: 37.22,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [-1.196, 1.93],
                      [-2.072, 1.101],
                      [-2.652, 0],
                      [-1.007, -0.154],
                      [-0.284, -0.071],
                      [0, 0],
                      [0.923, 0.024],
                      [0.615, 0],
                      [2.604, -1.681],
                      [0.994, -2.699],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, -2.462],
                      [1.195, -1.929],
                      [2.071, -1.101],
                      [1.113, 0],
                      [1.006, 0.154],
                      [0, 0],
                      [-0.474, -0.047],
                      [-0.923, -0.023],
                      [-3.267, 0],
                      [-2.605, 1.681],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.051, 0],
                      [16.051, -34.517],
                      [17.844, -41.104],
                      [22.745, -45.65],
                      [29.83, -47.301],
                      [33.008, -47.07],
                      [34.943, -46.733],
                      [34.943, -55.256],
                      [32.848, -55.362],
                      [30.54, -55.398],
                      [21.733, -52.876],
                      [16.335, -46.307],
                      [15.767, -46.307],
                      [15.767, -54.545],
                      [7.67, -54.545],
                      [7.67, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "r",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "r",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "a",
      size: 18,
      style: "Regular",
      w: 56.39,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-2.202, 0.947],
                      [-1.326, 1.349],
                      [-0.568, 1.184],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.42, 2.581],
                      [2.142, 1.278],
                      [2.284, 0.414],
                      [1.752, 0],
                      [2.829, -0.746],
                      [2.379, -1.858],
                      [1.42, -3.314],
                      [0, 0],
                      [-2.273, 1.752],
                      [-4.001, 0],
                      [-1.906, -1.941],
                      [0, -3.503],
                      [0, 0],
                      [0.959, -0.544],
                      [2.071, -0.225],
                      [3.314, -0.426],
                      [2.497, -0.556],
                      [2.06, -1.113],
                      [1.231, -1.953],
                      [0, -3.125],
                      [-1.657, -2.497],
                      [-2.818, -1.314],
                      [-3.457, 0],
                    ],
                    o: [
                      [2.202, -0.947],
                      [1.326, -1.349],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -4.332],
                      [-1.42, -2.58],
                      [-2.143, -1.278],
                      [-2.285, -0.414],
                      [-2.747, 0],
                      [-2.829, 0.746],
                      [-2.379, 1.859],
                      [0, 0],
                      [0.923, -1.989],
                      [2.273, -1.752],
                      [3.859, 0],
                      [1.905, 1.941],
                      [0, 0],
                      [0, 1.349],
                      [-0.959, 0.545],
                      [-2.072, 0.225],
                      [-2.534, 0.332],
                      [-2.498, 0.557],
                      [-2.06, 1.113],
                      [-1.231, 1.953],
                      [0, 3.551],
                      [1.657, 2.498],
                      [2.817, 1.314],
                      [3.172, 0],
                    ],
                    v: [
                      [31.783, -0.142],
                      [37.074, -3.587],
                      [39.915, -7.386],
                      [40.341, -7.386],
                      [40.341, 0],
                      [48.722, 0],
                      [48.722, -35.938],
                      [46.591, -46.307],
                      [41.246, -52.095],
                      [34.606, -54.634],
                      [28.551, -55.256],
                      [20.188, -54.137],
                      [12.376, -50.231],
                      [6.676, -42.472],
                      [14.631, -39.631],
                      [19.425, -45.241],
                      [28.835, -47.869],
                      [37.482, -44.957],
                      [40.341, -36.79],
                      [40.341, -36.506],
                      [38.903, -33.665],
                      [34.357, -32.511],
                      [26.278, -31.534],
                      [18.732, -30.202],
                      [11.896, -27.699],
                      [6.96, -23.1],
                      [5.114, -15.483],
                      [7.599, -6.41],
                      [14.311, -0.692],
                      [23.722, 1.278],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "a",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [2.166, 1.48],
                      [0, 2.912],
                      [-1.149, 1.243],
                      [-1.882, 0.628],
                      [-2.178, 0.284],
                      [-1.456, 0.178],
                      [-1.551, 0.249],
                      [-1.196, 0.343],
                      [-0.355, 0.426],
                      [0, 0],
                      [1.172, -2.06],
                      [2.284, -1.302],
                      [3.314, 0],
                    ],
                    o: [
                      [-2.166, -1.479],
                      [0, -2.131],
                      [1.148, -1.243],
                      [1.882, -0.627],
                      [0.899, -0.118],
                      [1.456, -0.178],
                      [1.55, -0.249],
                      [1.195, -0.343],
                      [0, 0],
                      [0, 2.273],
                      [-1.172, 2.06],
                      [-2.285, 1.302],
                      [-3.338, 0],
                    ],
                    v: [
                      [16.744, -8.469],
                      [13.494, -15.057],
                      [15.217, -20.117],
                      [19.762, -22.923],
                      [25.852, -24.29],
                      [29.386, -24.734],
                      [33.896, -25.373],
                      [38.015, -26.261],
                      [40.341, -27.415],
                      [40.341, -19.744],
                      [38.583, -13.246],
                      [33.398, -8.203],
                      [25, -6.25],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "a",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "a",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "v",
      size: 18,
      style: "Regular",
      w: 55.68,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [43.182, -54.545],
                      [28.125, -11.08],
                      [27.557, -11.08],
                      [12.5, -54.545],
                      [3.409, -54.545],
                      [23.58, 0],
                      [32.102, 0],
                      [52.273, -54.545],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "v",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "v",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "i",
      size: 18,
      style: "Regular",
      w: 23.72,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [16.051, 0],
                      [16.051, -54.545],
                      [7.67, -54.545],
                      [7.67, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "i",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-1.172, 1.113],
                      [0, 1.562],
                      [1.172, 1.113],
                      [1.634, 0],
                      [1.172, -1.113],
                      [0, -1.562],
                      [-1.172, -1.113],
                      [-1.634, 0],
                    ],
                    o: [
                      [1.172, -1.113],
                      [0, -1.562],
                      [-1.172, -1.113],
                      [-1.634, 0],
                      [-1.172, 1.113],
                      [0, 1.562],
                      [1.172, 1.113],
                      [1.634, 0],
                    ],
                    v: [
                      [16.14, -65.305],
                      [17.898, -69.318],
                      [16.14, -73.331],
                      [11.932, -75],
                      [7.724, -73.331],
                      [5.966, -69.318],
                      [7.724, -65.305],
                      [11.932, -63.636],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "i",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "i",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "e",
      size: 18,
      style: "Regular",
      w: 58.24,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-2.96, 1.148],
                      [-2.012, 2.072],
                      [-0.852, 2.747],
                      [0, 0],
                      [1.302, -1.266],
                      [1.787, -0.627],
                      [2.202, 0],
                      [2.557, 1.48],
                      [1.432, 2.853],
                      [0, 4.119],
                      [0, 0],
                      [-1.302, 2.628],
                      [-2.427, 1.646],
                      [-3.338, 0],
                      [-2.237, -1.397],
                      [-1.22, -2.415],
                      [0, -3.077],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.349, 3.48],
                      [2.273, 2.119],
                      [2.77, 0.947],
                      [2.841, 0],
                      [3.681, -2.403],
                      [2.047, -4.273],
                      [0, -5.587],
                      [-2.048, -4.202],
                      [-3.8, -2.332],
                      [-5.256, 0],
                    ],
                    o: [
                      [2.959, -1.148],
                      [2.012, -2.071],
                      [0, 0],
                      [-0.71, 1.894],
                      [-1.302, 1.267],
                      [-1.788, 0.628],
                      [-3.386, 0],
                      [-2.557, -1.479],
                      [-1.433, -2.853],
                      [0, 0],
                      [0, -3.006],
                      [1.302, -2.628],
                      [2.426, -1.645],
                      [3.03, 0],
                      [2.237, 1.397],
                      [1.219, 2.415],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -5.09],
                      [-1.349, -3.48],
                      [-2.273, -2.118],
                      [-2.77, -0.947],
                      [-4.924, 0],
                      [-3.682, 2.403],
                      [-2.048, 4.274],
                      [0, 5.587],
                      [2.047, 4.203],
                      [3.8, 2.332],
                      [3.693, 0],
                    ],
                    v: [
                      [40.518, -0.586],
                      [47.976, -5.415],
                      [52.273, -12.642],
                      [44.176, -14.915],
                      [41.158, -10.174],
                      [36.523, -7.333],
                      [30.54, -6.392],
                      [21.626, -8.612],
                      [15.643, -15.11],
                      [13.494, -25.568],
                      [13.494, -30.398],
                      [15.447, -38.849],
                      [21.04, -45.259],
                      [29.688, -47.727],
                      [37.589, -45.632],
                      [42.773, -39.915],
                      [44.602, -31.676],
                      [11.08, -31.676],
                      [11.08, -24.432],
                      [53.125, -24.432],
                      [53.125, -27.983],
                      [51.101, -40.838],
                      [45.668, -49.237],
                      [38.104, -53.835],
                      [29.688, -55.256],
                      [16.779, -51.651],
                      [8.185, -41.637],
                      [5.114, -26.847],
                      [8.185, -12.163],
                      [16.957, -2.362],
                      [30.54, 1.136],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "e",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "e",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "t",
      size: 18,
      style: "Regular",
      w: 36.36,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [3.125, -54.545],
                      [3.125, -47.443],
                      [31.392, -47.443],
                      [31.392, -54.545],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "t",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-1.48, -2.083],
                      [-2.261, -1.018],
                      [-2.368, 0],
                      [-1.018, 0.225],
                      [-0.568, 0.213],
                      [0, 0],
                      [0.591, -0.107],
                      [0.923, 0],
                      [1.101, 0.391],
                      [0.698, 1.172],
                      [0, 2.368],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 3.173],
                      [1.479, 2.084],
                      [2.261, 1.018],
                      [1.562, 0],
                      [1.018, -0.225],
                      [0, 0],
                      [-0.355, 0.071],
                      [-0.592, 0.107],
                      [-1.231, 0],
                      [-1.101, -0.391],
                      [-0.699, -1.172],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [11.364, -13.352],
                      [13.583, -5.469],
                      [19.194, -0.817],
                      [26.136, 0.71],
                      [30.007, 0.373],
                      [32.386, -0.284],
                      [30.682, -7.812],
                      [29.261, -7.546],
                      [26.989, -7.386],
                      [23.491, -7.972],
                      [20.792, -10.316],
                      [19.744, -15.625],
                      [19.744, -67.614],
                      [11.364, -67.614],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "t",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "t",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "y",
      size: 18,
      style: "Regular",
      w: 55.68,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-2.024, 0.899],
                      [-1.539, 1.858],
                      [-1.042, 2.817],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.219, -1.243],
                      [1.562, -0.142],
                      [2.036, 0.52],
                      [0, 0],
                      [-1.113, -0.225],
                      [-1.42, 0],
                    ],
                    o: [
                      [2.024, -0.9],
                      [1.539, -1.859],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-1.018, 2.77],
                      [-1.22, 1.243],
                      [-1.562, 0.142],
                      [0, 0],
                      [0.426, 0.213],
                      [1.113, 0.225],
                      [2.533, 0],
                    ],
                    v: [
                      [19.904, 19.105],
                      [25.249, 14.968],
                      [29.119, 7.955],
                      [52.273, -54.545],
                      [43.182, -54.545],
                      [28.125, -11.08],
                      [27.557, -11.08],
                      [12.5, -54.545],
                      [3.409, -54.545],
                      [23.58, 0.284],
                      [22.017, 4.545],
                      [18.661, 10.565],
                      [14.489, 12.642],
                      [9.091, 12.074],
                      [6.96, 19.46],
                      [9.268, 20.117],
                      [13.068, 20.455],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "y",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "y",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "c",
      size: 18,
      style: "Regular",
      w: 55.82,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-3.042, 1.503],
                      [-1.859, 2.569],
                      [-0.474, 3.22],
                      [0, 0],
                      [1.231, -1.42],
                      [1.776, -0.757],
                      [2.178, 0],
                      [2.45, 1.728],
                      [1.337, 3.125],
                      [0, 4.214],
                      [-1.362, 3.066],
                      [-2.45, 1.693],
                      [-3.267, 0],
                      [-2.19, -1.929],
                      [-0.639, -2.486],
                      [0, 0],
                      [1.965, 2.557],
                      [3.077, 1.42],
                      [3.835, 0],
                      [3.681, -2.403],
                      [2.047, -4.249],
                      [0, -5.54],
                      [-1.989, -4.238],
                      [-3.693, -2.415],
                      [-5.114, 0],
                    ],
                    o: [
                      [3.042, -1.503],
                      [1.858, -2.568],
                      [0, 0],
                      [-0.521, 1.989],
                      [-1.231, 1.42],
                      [-1.776, 0.758],
                      [-3.315, 0],
                      [-2.45, -1.728],
                      [-1.338, -3.125],
                      [0, -4.119],
                      [1.361, -3.066],
                      [2.45, -1.692],
                      [3.693, 0],
                      [2.189, 1.93],
                      [0, 0],
                      [-0.474, -3.409],
                      [-1.965, -2.557],
                      [-3.078, -1.42],
                      [-4.924, 0],
                      [-3.682, 2.403],
                      [-2.048, 4.25],
                      [0, 5.445],
                      [1.989, 4.238],
                      [3.693, 2.415],
                      [4.024, 0],
                    ],
                    v: [
                      [40.43, -1.119],
                      [47.781, -7.227],
                      [51.278, -15.909],
                      [42.898, -15.909],
                      [40.27, -10.795],
                      [35.76, -7.528],
                      [29.83, -6.392],
                      [21.183, -8.984],
                      [15.501, -16.264],
                      [13.494, -27.273],
                      [15.536, -38.05],
                      [21.254, -45.188],
                      [29.83, -47.727],
                      [38.654, -44.833],
                      [42.898, -38.21],
                      [51.278, -38.21],
                      [47.621, -47.159],
                      [40.057, -53.125],
                      [29.688, -55.256],
                      [16.779, -51.651],
                      [8.185, -41.673],
                      [5.114, -26.989],
                      [8.097, -12.464],
                      [16.619, -2.486],
                      [29.83, 1.136],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "c",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "c",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "l",
      size: 18,
      style: "Regular",
      w: 23.72,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [7.67, -72.727],
                      [7.67, 0],
                      [16.051, 0],
                      [16.051, -72.727],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "l",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "l",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
    {
      ch: "s",
      size: 18,
      style: "Regular",
      w: 52.27,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [3.089, 2.368],
                      [5.398, 0],
                      [3.018, -1.349],
                      [1.74, -2.367],
                      [0, -3.077],
                      [-2.332, -2.497],
                      [-4.995, -1.184],
                      [0, 0],
                      [-1.326, -1.29],
                      [0, -1.894],
                      [2.308, -1.669],
                      [3.906, 0],
                      [2.118, 1.468],
                      [0.757, 2.936],
                      [0, 0],
                      [-3.646, -2.415],
                      [-5.564, 0],
                      [-3.196, 1.42],
                      [-1.788, 2.462],
                      [0, 3.125],
                      [2.391, 2.427],
                      [4.877, 1.184],
                      [0, 0],
                      [1.515, 1.207],
                      [0, 2.084],
                      [-2.214, 1.527],
                      [-3.338, 0],
                      [-1.563, -0.781],
                      [-0.912, -1.195],
                      [-0.474, -1.255],
                      [0, 0],
                    ],
                    o: [
                      [-3.089, -2.367],
                      [-3.835, 0],
                      [-3.018, 1.349],
                      [-1.74, 2.368],
                      [0, 3.764],
                      [2.332, 2.498],
                      [0, 0],
                      [2.746, 0.639],
                      [1.326, 1.291],
                      [0, 2.344],
                      [-2.308, 1.669],
                      [-3.433, 0],
                      [-2.119, -1.468],
                      [0, 0],
                      [0.97, 4.64],
                      [3.645, 2.415],
                      [4.238, 0],
                      [3.196, -1.42],
                      [1.787, -2.462],
                      [0, -3.811],
                      [-2.391, -2.426],
                      [0, 0],
                      [-3.22, -0.805],
                      [-1.515, -1.207],
                      [0, -2.344],
                      [2.213, -1.527],
                      [2.438, 0],
                      [1.562, 0.781],
                      [0.911, 1.196],
                      [0, 0],
                      [-1.302, -3.882],
                    ],
                    v: [
                      [39.719, -51.705],
                      [26.989, -55.256],
                      [16.708, -53.232],
                      [9.57, -47.656],
                      [6.96, -39.489],
                      [10.458, -30.096],
                      [21.449, -24.574],
                      [30.54, -22.443],
                      [36.648, -19.549],
                      [38.636, -14.773],
                      [35.174, -8.754],
                      [25.852, -6.25],
                      [17.525, -8.452],
                      [13.21, -15.057],
                      [5.256, -13.068],
                      [12.18, -2.486],
                      [25.994, 1.136],
                      [37.145, -0.994],
                      [44.62, -6.818],
                      [47.301, -15.199],
                      [43.714, -24.556],
                      [32.812, -29.972],
                      [24.716, -31.96],
                      [17.614, -34.979],
                      [15.341, -39.915],
                      [18.661, -45.721],
                      [26.989, -48.011],
                      [32.99, -46.839],
                      [36.701, -43.874],
                      [38.778, -40.199],
                      [46.307, -42.33],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "s",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "s",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Inter",
    },
  ],
};
